export default __webpack_public_path__ + "static/media/copper_standard.8ef522f9.svg";